import React from "react";
import '../../css/elements.css';
import { toggleSelectedOption,toggleSearch } from "../../features/leadFilterSlice";
import { useSelector, useDispatch } from 'react-redux';


function RemoveableOption({}) {
    const dispatch=useDispatch();
    const selectedOptions = useSelector(state => state.filterSearch.selectedOptions);
    const removeOption=(option)=>{
        dispatch(toggleSearch({search:option.option,option:option.search}))
        dispatch(toggleSelectedOption(option))
    }
    return (
        selectedOptions.length > 0 && selectedOptions.map((option, index) => (
            <div className="removeableOption" key={`removable${index}`}>
                <span className="removeableRemove" onClick={()=>removeOption(option)}>X</span>
                <span className="removeableTitle">{option.name ? option.name : option.search}</span>
            </div>
        ))
    );
}

export default RemoveableOption;

 